import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-folder.tsx
/**
* icon.24.folder
*
* Keywords: directory, open, storage, file-system, organization, container, archive, access
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEwLjM3OSA2YTIgMiAwIDAgMSAxLjQxNC41ODZMMTMuMjA3IDhIMTYuNWEyIDIgMCAwIDEgMiAydjUuNWEyIDIgMCAwIDEtMiAyaC05YTIgMiAwIDAgMS0yLTJWOGEyIDIgMCAwIDEgMi0yek03LjUgN2ExIDEgMCAwIDAtMSAxdjcuNWExIDEgMCAwIDAgMSAxaDlhMSAxIDAgMCAwIDEtMVYxMGExIDEgMCAwIDAtMS0xaC0zLjcwN2wtMS43MDctMS43MDdBMSAxIDAgMCAwIDEwLjM3OSA3em04IDdhLjUuNSAwIDAgMSAwIDFoLTdhLjUuNSAwIDAgMSAwLTF6Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-1585
*/
const Icon24Folder = memo(function Icon24Folder(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M10.379 6a2 2 0 0 1 1.414.586L13.207 8H16.5a2 2 0 0 1 2 2v5.5a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zM7.5 7a1 1 0 0 0-1 1v7.5a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1h-3.707l-1.707-1.707A1 1 0 0 0 10.379 7zm8 7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1z"
		})
	});
});
//#endregion
export { Icon24Folder };

//# sourceMappingURL=icon-24-folder.js.map